import { Navigate } from 'react-router-dom';
import { RoutePaths } from '@utils/route.utils.ts';
import useTokenStore from '@store/token-store/token.store.ts';
import React from 'react';

const BlockAuthenticatedAccessGuard = ({
  children
}: {
  children: React.ReactNode;
}) => {
  const accessToken = useTokenStore((state) => state.accessToken);
  const superAdminAccessToken = useTokenStore(
    (state) => state.superAdminAccessToken
  );

  if (accessToken || superAdminAccessToken) {
    if (superAdminAccessToken) {
      return (
        <Navigate to={RoutePaths.Core.HotelManagement.absolutePath} replace />
      );
    } else {
      return <Navigate to={RoutePaths.Core.Analytics.absolutePath} replace />;
    }
  }

  return children;
};

export default BlockAuthenticatedAccessGuard;
